import React from 'react'

const StarRatings = ({selectedRating, setSelectedRating}) => {
    const [hoverText, setHoverText] = React.useState(0)

    const fillInStars = (star) => {
        if(selectedRating === 0) {
            if (star === 1) {setHoverText('Poor')}
            else if (star === 2) {setHoverText('OK')}
            else if (star === 3) {setHoverText('Average')}
            else if (star === 4) {setHoverText('Good')}
            else if (star === 5) {setHoverText('Excellent')}
            for(let i = 0; i < star; i++) {
                document.getElementById(`star-${i}`).style.fill = '#FBBC00'
            }
        }
    }
    const clearYellowStars = () => {
        if(selectedRating === 0) {
            setHoverText(0)
            for(let i = 0; i < 5; i++) {
                document.getElementById(`star-${i}`).style.fill = 'rgb(200, 200, 200)'
            }
        }
    }

    const chooseARating = (star) => {
        for(let i = 0; i < 5; i++) {
            document.getElementById(`star-${i}`).style.fill = 'rgb(200, 200, 200)'
        }
        if (star === 1) {setHoverText('Poor')}
        else if (star === 2) {setHoverText('OK')}
        else if (star === 3) {setHoverText('Average')}
        else if (star === 4) {setHoverText('Good')}
        else if (star === 5) {setHoverText('Excellent')}
        for(let i = 0; i < star; i++) {
            document.getElementById(`star-${i}`).style.fill = '#FBBC00'
        }
        setSelectedRating(star)
    }

    return (
        <div className="star-box">
        <svg className="each-star">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(1)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(1)}>
                <g id="star-0" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                    <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                </g>
            </g>
        </svg>
        <svg className="each-star">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(2)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(2)}>
                <g id="star-1" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                    <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                </g>
            </g>
        </svg>
        <svg className="each-star">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(3)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(3)}>
                <g id="star-2" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                    <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                </g>
            </g>
        </svg>
        <svg className="each-star">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(4)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(4)}>
                <g id="star-3" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                    <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                </g>
            </g>
        </svg>
        <svg className="each-star">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" onMouseEnter={() => fillInStars(5)} onMouseLeave={() => clearYellowStars()} onClick={() => chooseARating(5)}>
                <g id="star-4" transform="translate(-385.000000, -931.000000)" fill="rgb(200, 200, 200)">
                    <polygon id="Star-Copy" points="401.5 953.839042 391.801543 960.84878 395.471213 949.458872 385.807567 942.40122 397.774005 942.371608 401.5 931 405.225995 942.371608 417.192433 942.40122 407.528787 949.458872 411.198457 960.84878"></polygon>
                </g>
            </g>
        </svg>
    </div>
    )
}
export default StarRatings